<template>
  <div class="d-flex flex-column daytime-advice-search-view-page">
    <div class="d-flex daytime-advice-search-view-content">
      <v-container
        fluid
        class="pa-2 daytime-advice-search-view"
      >
        <v-row class="pa-4 pt-6 pb-0 daytime-advice-search-view-row">
          <v-col
            cols="6"
            sm="6"
            md="6"
            class="pt-0"
          >
            <daytime-advice-sheet-body
              :editing="editing"
            />
            <v-row>
              <v-col>
                <p class="text-md-center pink--text">
                  ※ 運営からのお知らせ ※
                </p>
                <p
                  style="white-space: pre-wrap; line-height: 25px"
                  v-html="daytimeAdviceReferenceInfo.content"
                />
              </v-col>
            </v-row>
            <daytime-advice-images />
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            class="pa-4"
            style="height: 94%;"
          >
            <span class="pa-2">
              <b>ユーザ: </b>
              <span>{{ daytimeAdviceSheet.userName }}
                (ID: {{ daytimeAdviceSheet.userId }})</span>
            </span>
            <chat-view
              :chat-id="parseInt($route.params.id)"
              log-type="daytimeAdvice"
            />
          </v-col>
        </v-row>
      </v-container>
      <daytime-advice-sheet-sidebar
        v-if="daytimeAdviceSheet.id != null"
        class="flex-grow-0 d-none d-sm-flex"
      />
    </div>
    <daytime-advice-action-bar>
      <template v-if="editing">
        <v-btn
          color="teal"
          class="font-weight-bold"
          theme="dark"
          @click="saveSheet()"
        >
          保存する
        </v-btn>
        <v-btn
          variant="outlined"
          color="teal"
          @click="cancel()"
        >
          キャンセル
        </v-btn>
      </template>
      <v-btn
        v-else
        :color="editableSheet() ? 'teal' : 'grey'"
        :disabled="!editableSheet()"
        class="font-weight-bold"
        theme="dark"
        @click="startEditing()"
      >
        編集する
      </v-btn>
    </daytime-advice-action-bar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import outcomeOptions from "../mixins/outcome_options.js";
import ChatView from "./shared/ChatView.vue";
import DaytimeAdviceSheetBody from "./shared/DaytimeAdviceSheetBody.vue";
import DaytimeAdviceImages from "./shared/DaytimeAdviceImages.vue";
import DaytimeAdviceActionBar from "./shared/DaytimeAdviceActionBar.vue";
import { DaytimeAdviceSheetSidebar } from "@/vue/widgets/daytime-advice-sheet-sidebar";

export default {
  name: "DaytimeAdviceSearchView",
  components: {
    ChatView,
    DaytimeAdviceSheetBody,
    DaytimeAdviceImages,
    DaytimeAdviceActionBar,
    DaytimeAdviceSheetSidebar
  },
  mixins: [outcomeOptions],
  data: () => ({
    editing: false,
  }),
  computed: {
    ...mapGetters([
      "daytimeAdviceSheet",
      "daytimeAdviceReferenceInfo",
    ])
  },
  watch: {
    "$route" () {
      this.clearData();
      this.fetchData();
    }
  },
  created() {
    this.fetchData();
  },
  unmounted() {
    this.clearData();
  },
  methods: {
    ...mapActions(["updateDaytimeAdviceSheet", "findUser", "resetUser"]),
    fetchData: function() {
      this.$store.dispatch("fetchDaytimeAdviceSheet", {
        id: this.$route.params.id
      });
      this.$store.dispatch("fetchDaytimeAdviceReferenceInfo", {
        id: this.$route.params.id
      });
    },
    clearData: function(){
      this.$store.dispatch("clearDaytimeAdviceSheet");
      this.resetUser();
    },
    startEditing: function() {
      this.editing = true;
    },
    saveSheet: function() {
      this.updateDaytimeAdviceSheet(this.daytimeAdviceSheet).then(() => {
        // TODO: エラーハンドリング
        this.editing = false;
      });
    },
    endEditing: function() {
      this.editing = false;
    },
    cancel: function() {
      this.endEditing();
      // 入力データをリセットする
      this.$store.dispatch("fetchDaytimeAdviceSheet", {
        id: this.$route.params.id
      });
      this.findUser({ userId: this.daytimeAdviceSheet.userId });
    },
    editableSheet: function() {
      // 対応中, 相談終了, 対応時間終了 の場合は編集可能
      return this.daytimeAdviceSheet.status == "in_process" ||
        this.daytimeAdviceSheet.status == "done" ||
        this.daytimeAdviceSheet.status == "time_over";
    },
  }
};
</script>
<style lang="scss">
.daytime-advice-search-view .chat-logs-view {
  height: 100%;
}

// ナビゲーション・タブ(担当/検索)は常に画面上部に固定表示させるため、
// このページ自体はビューポート内(ナビ・タブの高さを除いた分)に高さを収め、
// はみ出す分は内部の各領域(v-row/チャット/サイドバー)でスクロールさせる
.daytime-advice-search-view-page {
  height: calc(100vh - 96px); /* 96px = compact TopMenu(48px) + v-tabs(48px) */
  overflow: hidden;
}

// ボトムバーの上に来る領域（メインカラム + サイドバー）
// DaytimeAdviceActionBarはposition: fixedで画面下端に固定されるため、
// その高さ分(64px)を確保して本文がバーの下に隠れないようにする
.daytime-advice-search-view-content {
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 64px;
}

.daytime-advice-search-view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.daytime-advice-search-view-row {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>
